export default "__VITE_ASSET__D1cdx3TI__"